import React, { useContext, useState, useEffect } from 'react'
import withConfig from '../../../wrappers/withConfig'
import toast from '../../../elem/Toast'
import { CurrentProcessContext } from '../../../wrappers/CurrentProcessContext'
import LoadingSpinner from '../../../elem/LoadingSpinner'
import useModal from '../../../hooks/useModal'
import { ConfirmModal } from '../../../elem/Modal'
import { DateSelector } from '../../../elem/Selectors'
import { dateToString, saveDate, daysUntilDate, dateAfterDays} from '../../../../utils/formatDate'
import { FaEdit } from 'react-icons/fa'
import { APIRequestContext } from '../../../wrappers/APIRequestWithToken'

const ActionSelect = ({ options, maxDuration, item, config }) => {
    const { isShowing, toggle } = useModal()
    const { fetchWithToken } = useContext(APIRequestContext)
    const { setAction, transitions, setEditDate } = useContext(
        CurrentProcessContext
    )
    const [loading, setLoading] = useState(false)
    const { API_URL } = config

    const [transition, setTransition] = useState(
        options ? options[0].ProcessStateTransitionId : null
    )
    const [option, setOption] = useState(options ? options[0] : null)
    const [editDur, setEditDur] = useState(false)
    const [calendarOpen, setCalendarOpen] = useState(false)
    const [date, setDate] = useState(null)
    const [duration, setDuration] = useState(null)
    const [originalDate, setOriginalDate] = useState(null)

    useEffect(() => {
        if (options) {
            setTransition(options[0].ProcessStateTransitionId)
            setOption(options[0])
        }
    }, [options])

    useEffect(() => {
        if (isShowing) {
            const next = transitions.filter(
                (x) => x.CurrentStateId === option.NextStateId
            )
            const nextDueDate = next.map((y) =>
                dateAfterDays(y.StateMaxDurationDays)
            )[0]
            if (nextDueDate && next.length) {
                setOriginalDate(nextDueDate)
                setDate(nextDueDate)
                setDuration(next[0].StateMaxDurationDays)
            }
        }
    }, [isShowing])

    if (maxDuration === -1 || !options) {
        return null
    }

    const handleChange = (e) => {
        setTransition(Number(e.target.value))
        const selectedOption = options.filter(
            (item) => item.ProcessStateTransitionId == e.target.value
        )[0]
        if(selectedOption){
            setOption(selectedOption)
        }
    }

    const POST = (action) => {
        const formData = new FormData()
        formData.append('ProcessId', action.ProcessId)
        formData.append('ExternalDataItemId', action.ExternalDataItemId)
        formData.append('TransitionId', action.TransitionId)
        return {
            method: 'POST',
            mode: 'cors',
            headers: {
                // 'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers':
                    'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
            },
            body: formData,
        }
    }
    const executeTransition = () => {
        if (!item.ExternalDataItemId || !transition) {
            console.log(item.ExternalDataItemId, transition, item, 'error')
        }

        setLoading(true) // set the loading to true
        fetchWithToken(
            `${API_URL}/Process/executeTransition`,
            POST({
                ProcessId: options[0].ProcessId,
                ExternalDataItemId: item.ExternalDataItemId,
                TransitionId: transition,
            })
        )
            .then(async (response) => {
                if (response.ok) {
                    return response
                } else {
                    const error = await response.text()
                    throw new Error(error)
                }
            })
            .then(() => {
                if (date && dateToString(originalDate) !== dateToString(date)) {
                    setEditDate({
                        StartDate: saveDate(),
                        DueDate: saveDate(date),
                        ExternalDataItemId: [item.ExternalDataItemId],
                    })
                }
            })
            .catch((e) => {
                toast({
                    level: 'error',
                    message:
                        'Workflow Landing Page:' +
                        (e.message
                            ? e.message
                            : 'Unable to connect to the server'),
                })
            })
            .finally(() => {
                toggle()
                setAction(`${transition}_${item.ExternalDataItemId}`)
                setTimeout(() => setLoading(false), 1500)
            })
    }

    const cancel = () => {
        toggle()
    }

    const handleDateChange = (e) => {
        setDate(e)
        setDuration(daysUntilDate(e))
    }

    const handleDurationChange = (e) => {
        setDuration(Number(e.target.value))
        setDate(dateAfterDays(Number(e.target.value)))
    }

    const confirmation =
        option && isShowing ? (
            <div className="is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
                <p>
                    Are you sure you want to move this item to{' '}
                    {option.TransitionName} from {options[0].CurrentState}?{' '}
                </p>
                {date ? (
                    <p className="actionDate">
                        `The next action will be due in
                        {editDur ? (
                            <input
                                className="duration input"
                                type="number"
                                classname="input"
                                defaultValue={duration}
                                onChange={handleDurationChange}
                                onBlur={() => setEditDur(false)}
                            />
                        ) : (
                            <span
                                className="duration"
                                onClick={() => setEditDur(true)}
                            >
                                {' '}
                                {duration}
                                <FaEdit style={{ width: '.9em' }} />
                            </span>
                        )}{' '}
                        days on
                        {
                            <span>
                                <DateSelector
                                    onChange={handleDateChange}
                                    onFocus={() => setCalendarOpen(true)}
                                    onBlur={() => setCalendarOpen(false)}
                                    selected={date}
                                />
                                <FaEdit
                                    style={{
                                        width: '1em',
                                        display: `${
                                            calendarOpen ? 'none' : 'initial'
                                        }`,
                                    }}
                                />
                            </span>
                        }
                        `{' '}
                    </p>
                ) : null}
            </div>
        ) : null

    return (
        <>
            <div
                className="selectSection"
                style={{ color: 'inherit !important' }}
            >
                <div className="selectAction">
                    <select
                        className="select is-small is-rounded"
                        initialValue={options ? options[0] : null}
                        style={{ width: '140px' }}
                        onChange={handleChange}
                    >
                        {options.map((option, i) => (
                            <option
                                key={`action_option_${i}`}
                                value={option.ProcessStateTransitionId}
                            >
                                {option.TransitionName}
                            </option>
                        ))}
                    </select>
                    <div>
                        {loading === true ? (
                            <LoadingSpinner size="1.5em" />
                        ) : (
                            <button
                                onClick={toggle}
                                className="button is-small"
                            >
                                Go
                            </button>
                        )}
                    </div>
                    {isShowing ? (
                        <ConfirmModal
                            confirmation={confirmation}
                            cancel={cancel}
                            submit={executeTransition}
                            className="singleAction"
                        />
                    ) : null}
                </div>
            </div>
        </>
    )
}

export default withConfig(ActionSelect)
